
import { AbstractControl} from '@angular/forms';

export class CustomValidators {
  constructor() {}

  static passwordMatcher(control: AbstractControl): {[key: string]: boolean } {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');
    if (password.value !== confirmPassword.value) return { passwordMatch: false };
    else return null;
  }
}

